import { FileText, PhoneCall, TruckIcon } from "lucide-react";

export const HowItWorks = () => {
  const steps = [
    {
      number: "01",
      icon: FileText,
      title: "Request a Quote",
      description: "Fill out our simple form with pickup and drop-off postcodes, vehicle details, and service type. We'll respond promptly with a competitive quote."
    },
    {
      number: "02",
      icon: PhoneCall,
      title: "Confirm Details",
      description: "Once you approve the quote, we'll confirm all details with you and schedule the collection at a time that suits you best."
    },
    {
      number: "03",
      icon: TruckIcon,
      title: "Safe Transport",
      description: "Our professional team collects your vehicle and transports it safely to the destination. Stay updated with real-time tracking."
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-slate-600 font-semibold uppercase tracking-wider text-sm">
            Simple Process
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mt-3 mb-4">
            How It Works
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Getting your vehicle transported is easy with our streamlined three-step process
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <div key={index} className="relative">
                {/* Connector line for desktop */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-16 left-1/2 w-full h-0.5 bg-slate-200 -z-0">
                    <div className="absolute right-0 top-1/2 -translate-y-1/2 w-3 h-3 bg-slate-300 rounded-full"></div>
                  </div>
                )}

                <div className="relative z-10 text-center">
                  <div className="inline-flex items-center justify-center w-32 h-32 bg-white rounded-2xl shadow-lg border-2 border-slate-100 mb-6">
                    <div className="relative">
                      <span className="absolute -top-2 -right-2 text-6xl font-bold text-slate-100">
                        {step.number}
                      </span>
                      <IconComponent className="w-12 h-12 text-slate-900 relative z-10" />
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
